export function getDefaultQueryKey<T extends (...args: any) => any>(
  queryFn: T,
  params?: Parameters<T>[0]
) {
  return [queryFn.name, params ?? {}]
}
